import type { FC } from "react";

import { SUMMARY_CARD_HEIGHT } from "app/pages/keyword-research/website-analysis/pages/seo-overview/summary/consts";
import type { ITrafficDistributionData } from "app/pages/keyword-research/website-analysis/pages/seo-overview/types";

import { TrafficDistribution } from "./TrafficDistribution";
import { brandedTiersConfig, searchTiersConfig, titles } from "./trafficDistributionConsts";
import { TrafficDistributionWrapper } from "./TrafficDistributionStyledComponents";
import { ETrafficDistributionTypes } from "./trafficDistributionTypes";
import { transformTrafficData } from "./trafficDistributionUtils";

const CONTAINER_HEIGHT = `${SUMMARY_CARD_HEIGHT}px`;

interface ITrafficDistributionContainerProps {
    data: ITrafficDistributionData;
    isLoading: boolean;
}
export const TrafficDistributionContainer: FC<ITrafficDistributionContainerProps> = ({ data, isLoading }) => {
    return (
        <TrafficDistributionWrapper height={CONTAINER_HEIGHT}>
            <TrafficDistribution
                isLoading={isLoading}
                graphItems={transformTrafficData(data?.Search, searchTiersConfig)}
                titles={titles[ETrafficDistributionTypes.SEARCH]}
            />
            <TrafficDistribution
                isLoading={isLoading}
                graphItems={transformTrafficData(data?.Branded, brandedTiersConfig)}
                titles={titles[ETrafficDistributionTypes.BRANDED]}
            />
        </TrafficDistributionWrapper>
    );
};
